<div class="flex h-20 w-full justify-center bg-pl-gray-200">
  <div class="flex w-full max-w-content items-center justify-between px-4 md:px-0">
    <div class="h-11">
      <pl-button
        *ngIf="buttonLeft"
        class="block min-w-buttonsNavigation"
        [variant]="buttonLeft.variant"
        [padding]="ButtonPadding.small"
        [isDisabled]="!!buttonLeft.isDisabled"
        (click)="onButtonClicked(buttonLeft)"
      >
        <pl-icon *ngIf="buttonLeft.iconLeft" [name]="buttonLeft.iconLeft" class="h-5 w-5" /> {{ buttonLeft.label }}
      </pl-button>
    </div>
    <div class="h-11">
      <pl-button
        *ngIf="buttonRight"
        class="block min-w-buttonsNavigation"
        [variant]="buttonRight.variant"
        [padding]="ButtonPadding.small"
        [isDisabled]="!!buttonRight.isDisabled"
        (click)="onButtonClicked(buttonRight)"
      >
        {{ buttonRight.label }}
      </pl-button>
    </div>
  </div>
</div>
